export let tinyMceDefaultConfiguration = {
  plugins: 'link image preview media searchreplace fullscreen table insertdatetime paste wordcount',
  toolbar: 'undo redo | fontselect fontsizeselect formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | client',
  skin_url: '../../assets/skins/lightgray',
  base_url: '/tinymce',
  suffix: '.min',
  content_css: ['../../app/@theme/styles/innerLayout.css'],
  fontsize_formats: '7pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 20pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
};
